import {defineStore, storeToRefs} from 'pinia'
import type {OutputChatChannels, OutputChatMessage} from "~/models"
import {useCentrifugoStore} from "~/stores/centrifugo"


export const useChatMessagesStore = defineStore('chatMessages', {
    state: () => ({
        channelMessages: new Map<number, OutputChatMessage[]>(),
    }),
    getters: {},
    actions: {
        async load() {},

        handleCentrifugeNotification(message: {
            type: string,
            operation: string,
            channel: number,
            payload: OutputChatMessage
        }) {

            // Якщо прийшло щось інше, не обробляємо
            if (!message || message.type !== 'chat_messages') {
                return
            }

            const payload = message.payload as OutputChatMessage
            const operation = message.operation as string
            const channelId = message.channel as number
            if (!payload || !payload.id) {
                return
            }

            let channelMessages = this.channelMessages.get(channelId) || []

            switch (operation) {
                case 'insert':
                    // Додаємо нове повідомлення у масив
                    channelMessages.push(payload)
                    break

                case 'update':
                    // Знаходимо повідомлення по id і оновлюємо
                    const indexToUpdate = channelMessages.findIndex(ch => ch.id === payload.id)
                    if (indexToUpdate !== -1) {
                        channelMessages[indexToUpdate] = payload
                    } else {
                        // Хз, напевно можна додати, але чому його немає в списку загадка
                        channelMessages.push(payload)
                    }
                    break

                case 'delete':
                    // Фільтруємо непотрібний канал
                    channelMessages = channelMessages.filter(ch => ch.id !== payload.id)
                    break
            }

            // Після кожної операції зберігаємо алфавітне сортування:
            channelMessages.sort((a, b) => {
                return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            })

            this.channelMessages.set(channelId, channelMessages)
        }
    },
})
